module.exports = __webpack_public_path__ + "img/truck_idle.20ff7b02.svg";